







































import VueOptions from '@utils/VueOptions'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'
import ShippingAreaFilter from '@ui/ShippingArea/ShippingAreaFilter'

settings =
  name: 'VenueResourceList'

  vue:
    props: ['shippingAreas', 'infiniteWrapper', 'actions', 'options']
    components: {
      ResourceList,
      LoadingIndicator,
      ShippingAreaFilter,
    }

    data: ->
      isAllSelected: false
      selectedShippingAreas: []
      nextPage: 1
      target:
        scopes: []
        q: ''

    computed:
      components: ->
        'shipping-area-resource-list-item': () => import('./ShippingAreaResourceListItem')

      title: ->
        @options?.title || 'Shipping Addresses'

      resourceKey: ->
        @options?.resourceKey || 'shipping_areas'

      listItemActions: -> {}

    mounted: ->
      @nextPage = 1
      @hiInfiniteScroll()

    methods:
      hiApplyFilters: ->
        @$refs.infiniteLoading.stateChanger.reset()
        @nextPage = 1
        @actions.fetchResource null, @resourceKey, @target, { page: @nextPage }
        @nextPage += 1

      hiSearchChange: ->

      hiInfiniteScroll: (state) ->
        @actions.fetchResource state, @resourceKey, @target, { page: @nextPage }
        @nextPage += 1

      hiNavToShippingAreaEditor: ->
        query = {}
        query.shippingAreas = 'all' if @isAllSelected
        query.shippingAreas ||= @selectedShippingAreas.map((item) -> item.id)
        @$router.push { name: 'ShippingAreaBulkEditPage', query }

      hiNavToShippingAreaCreate: ->
        @$router.push { name: 'ShippingAreaCreatePage' }

      hiExport: ->
        @actions.exportShippingAreas @target

export default VueOptions.vue settings
